import useSWRImmutable from 'swr/immutable';
import { fetcherSS } from '@/modules/api';

export interface ICompointsRate {
  points: number;
  amountCents: number;
  currency: string;
}

export interface ICompointsRatesMoney {
  group: string;
  rates: ICompointsRate[];
  title: string;
  wager: number;
}

export const useCompPointsRatesMoney = () => {
  const {
    data = [],
    error,
    isLoading,
  } = useSWRImmutable<ICompointsRatesMoney[]>(
    '/comp_points/rates/money',
    fetcherSS
  );

  return {
    data,
    error,
    isLoading,
  };
};
